import { render } from "./newJourney.vue?vue&type=template&id=53b95732&scoped=true"
import script from "./newJourney.vue?vue&type=script&lang=js"
export * from "./newJourney.vue?vue&type=script&lang=js"

import "./newJourney.vue?vue&type=style&index=0&id=53b95732&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b95732"]])

export default __exports__